import { createContext, useContext, useEffect, useState } from 'react';

/** True when the client initialized from a server bootstrap, so gate values resolve on the
 * first render — SSR pass and hydration alike. */
export const StatsigBootstrapContext = createContext(false);

export const useStatsigBootstrapped = (): boolean => useContext(StatsigBootstrapContext);

/**
 * Whether gate values are safe to render. Without a bootstrap they aren't resolved on the
 * hydration render, so gate-driven output must wait for mount or the markup won't match.
 */
export const useStatsigGatesResolved = (): boolean => {
  const isBootstrapped = useStatsigBootstrapped();
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return isBootstrapped || isMounted;
};
